module.exports = __webpack_public_path__ + "static/media/11.96c6c9a8.wav";